import Button from "components/base/button/Button";
import React from "react";

const CardBottomSubmitBottom = ({
  isError,
  handleSubmit,
  label = "Submit",
}: {
  isError: boolean;
  handleSubmit: () => void;
  label: string;
}) => {
  return (
    <div className="row justify-content-end ">
      <div className="col-4">
        <div className="d-grid mt-4">
          <Button
            classes="btn-sm rounded btn-primary"
            onClick={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            disabled={isError}
          >
            <span className="text-capitalize"> {label}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CardBottomSubmitBottom;
